import * as React from 'react';
import { useSelector } from 'react-redux';
import { getSpecialPromos } from '../../selectors/developerV2';
import { SpecialPromosPreviewContainer } from '../SpecialPromosPreview';
import { SpecialPromosRedesign } from '../SpecialPromosRedesign';
import { SpecialPromosWrapper } from '../../components/SpecialPromosWrapper';
import { LinkButton } from '@cian/ui-kit';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { trackClickSpecialPromos, trackShowSpecialPromos } from '../SpecialPromos/tracking';

export const SpecialPromoRedesign = () => {
  const specialPromos = useSelector(getSpecialPromos);
  const promos = specialPromos?.promos;
  const promosPageLink = specialPromos?.promosPageLink;

  /* istanbul ignore next */
  if (!promos) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackShowSpecialPromos} triggerOnce>
      <SpecialPromosWrapper
        specialPromos={<SpecialPromosRedesign />}
        showAllPromos={
          <LinkButton
            target="_blank"
            fullWidth={true}
            theme="fill_secondary"
            size="L"
            href={promosPageLink}
            onClick={trackClickSpecialPromos}
          >
            Показать все
          </LinkButton>
        }
        specialPromosPreview={<SpecialPromosPreviewContainer />}
      />
    </ActionAfterViewObserver>
  );
};
